export const DEFAULT_EVENT_DURATION_MINUTES = 120;
export const MAX_EVENT_PRICE_THB = 10_000;
export const PAYMENT_HOLD_MINUTES = 30;
